<template>
  <label
    class="base-checkbox"
    :class="`base-checkbox--${align}`"
  >
    <input
      type="checkbox"
      :checked="modelValue"
      :disabled="disabled"
      @change="handleChange"
      class="checkbox-input"
    />
    <span
      class="checkbox-control"
      :class="{ 'is-checked': modelValue, 'is-disabled': disabled }"
    >
      <svg
        v-if="modelValue"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="currentColor"
      >
        <path
          d="M10 3L4.5 8.5L2 6"
          stroke="currentColor"
          stroke-width="2"
          fill="none"
        />
      </svg>
    </span>
    <span class="checkbox-label">
      <slot>{{ label }}</slot>
    </span>
  </label>
</template>

<script>
export default {
  name: "BaseCheckbox",

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },

    label: {
      type: String,
      default: "",
    },

    disabled: {
      type: Boolean,
      default: false,
    },
    align: {
      type: String,
      default: "center",
      validator: (value) => ["center", "start"].includes(value),
    },
  },

  emits: ["update:modelValue", "change"],

  methods: {
    handleChange(event) {
      if (this.disabled) return;

      const newValue = event.target.checked;
      this.$emit("update:modelValue", newValue);
      this.$emit("change", newValue);
    },
  },
};
</script>

<style scoped>
.base-checkbox {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}

.base-checkbox--start {
  align-items: flex-start;
}

.base-checkbox--start .checkbox-control {
  margin-top: 1px;
}

.checkbox-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.checkbox-control {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: 2px solid #999;
  border-radius: 4px;
  background: #fff;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.checkbox-control:hover {
  border-color: var(--color-green-hover);
}

.checkbox-control.is-checked {
  background: var(--color-green);
  border-color: var(--color-green);
}

.checkbox-control.is-checked svg {
  color: #fff;
}

.checkbox-control.is-disabled {
  background: #f8f9fa;
  border-color: #e9ecef;
  cursor: not-allowed;
}

.checkbox-control.is-disabled.is-checked {
  background: #6c757d;
  border-color: #6c757d;
}

.checkbox-label {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
}

.base-checkbox:has(.checkbox-input:disabled) {
  cursor: not-allowed;
  opacity: 0.6;
}

.base-checkbox:has(.checkbox-input:disabled) .checkbox-label {
  color: #6b7280;
}

.checkbox-input:focus + .checkbox-control {
  outline: none;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
  border-color: var(--color-green-hover);
}
</style>
